var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form client-data-popup"
  }, [_c('div', {
    staticClass: "content-form-popup client-data-popup-content"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Údaje klienta")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "client-profile"
    }
  }, [_vm._v("Uložiť")])]), _vm.clientInfo.type ? _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "client-data-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": "Sekcie údajov klienta"
    }
  }, [_c('button', {
    staticClass: "client-data-tab",
    "class": {
      active: _vm.activeSection === 'personal'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeSection === 'personal'
    },
    on: {
      "click": function click($event) {
        _vm.activeSection = 'personal';
      }
    }
  }, [_vm._v(" Osobné údaje ")]), _c('button', {
    staticClass: "client-data-tab",
    "class": {
      active: _vm.activeSection === 'bonita'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeSection === 'bonita'
    },
    on: {
      "click": function click($event) {
        _vm.activeSection = 'bonita';
      }
    }
  }, [_vm._v(" Bonita ")])]), _c('div', {
    staticClass: "client-data-form-wrapper"
  }, [_c('personal-info-form', {
    attrs: {
      "client": _vm.payload,
      "errors": _vm.errors,
      "active-section": _vm.activeSection
    },
    on: {
      "client-saved": function clientSaved($event) {
        return _vm.saveClient($event);
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }